export const membershipGuidePages = [
  {
    url: "introduction-to-ada",
    title: "Introduction to Ada",
    subPages: null,
  },
  {
    url: "dashboard-guide",
    title: "Dashboard Guide",
    subPages: null,
  },
  {
    url: null,
    title: "Update Data Guide",
    subPages: [
      { url: "update-data", title: "Update Data Workflow" },
      { url: "catalist-only-docs", title: "Catalist-Only Workflow" },
      { url: "download-data", title: "Downloading Data" },
    ],
  },
  {
    url: null,
    title: "API Documentation",
    subPages: [
      { url: "api-intro", title: "Introduction to Ada API" },
      { url: "api-token", title: "Obtain a Bearer Token" },
      { url: "api-upload-file", title: "Upload a Data File" },
      { url: "api-map-template", title: "Map a Template" },
      { url: "api-process-file", title: "Process a Template Mapping" },
      { url: "api-summary", title: "Examine Process Summary" },
      { url: "api-confirm-file", title: "Confirm File" },
      { url: "api-catalist-options", title: "Catalist Options" },
    ],
  },
  {
    url: "best-practices",
    title: "Best Practices Guide",
    subPages: null,
  },
  {
    url: "template-dictionary",
    title: "Ada Field Definitions",
    subPages: null,
  },
  { url: "glossary", title: "Glossary", subPages: null },
  { url: "release-notes", title: "Latest Features", subPages: null },
];

export const politicalGuidePages = [
  {
    url: "political-data-upload",
    title: "Volunteer Data Upload Guide",
    subPages: null,
  },
  {
    url: "political-data-return",
    title: "Volunteer Data Return Files",
    subPages: null,
  },
];
